<div *ngIf="error" class="alert alert-warning" role="alert">
  {{ errorMsg }}
</div>
<form (ngSubmit)="onSubmit()" [formGroup]="form" autocomplete="off">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <div class="row">
          <div class="col-4 pl-0">
            <label i18n>Tipo Documento
            </label>
            <select
              formControlName="tipodocumento"
              (change)="formatDocument($event)"
              class="form-control"
            >
              <option value="CNPJ">CNPJ</option>
              <option value="CPF">CPF</option>
            </select>
          </div>
          <div class="col-8 pr-0">
            <label>
              {{form.controls.tipodocumento.value}}
            </label>
            <input
              formControlName="numdocumento"
              (blur)="consultaCnpj($event)"
              name="numdocumento"
              type="text"
              [mask]="documentMask"
              [dropSpecialCharacters]="false"
              class="form-control"
              [readonly]="form.controls.tipodocumento.value==='' || this.edit"
            />
            <div
              *ngIf="error && form.get('numdocumento').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="row">
          <!-- <div class="col-4 pl-0">
            <label>Tipo Empresa</label>
            <select formControlName="tipo_empresa" class="form-control">
              <option *ngFor="let t of tipo_empresa" value="{{ t.id }}">
                {{ t.label }}
              </option>
            </select>
            <div
              *ngIf="error && form.get('tipo_empresa').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div> -->
          <div class="col-12 pl-0 pr-0">
            <label>Data Nascimento/Fundação</label>
            <input
            type="text"
            class="form-control form-control-sm"
            bsDatepicker
            formControlName="nascimento"
            placement="bottom left"
            name="nascimento"
            [bsConfig]="{
              isAnimated: true,
              dateInputFormat: 'DD/MM/YYYY'
            }"
          />
            <!-- <input
              formControlName="numDocumento2"
              placeholder="{{ documentLabel2 }}"
              name="numDocumento2"
              type="text"
              class="form-control"
              maxlength="20"
            /> -->
            <!-- <div
              *ngIf="error && form.get('numDocumento2').invalid"
              class="error"
            >
              Verifique este campo!
            </div> -->
          </div>
        </div>
      </div>
      <div class="form-group">
        <label>Nome</label>
        <input
          formControlName="nome"
          name="nome"
          type="text"
          maxlength="60"
          class="form-control"
        />
        <div *ngIf="error && form.get('nome').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="form-group">
        <label>Fantasia</label>
        <input
          formControlName="fantasia"
          name="fantasia"
          type="text"
          maxlength="255"
          class="form-control"
        />
        <div *ngIf="error && form.get('fantasia').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
      <div class="form-group">
        <label>Email</label>
        <input
          formControlName="email"
          name="email"
          type="email"
          maxlength="255"
          class="form-control"
        />
        <div *ngIf="error && form.get('email').invalid" class="error">
          Verifique este campo!
        </div>
      </div>
          <div class="form-group">
            <label>Referências Comerciais</label>
            <input
              maxlength="255"
              formControlName="observacao"
              name="observacao"
              type="text"
              class="form-control"
              (input)="sanitizeInput($event)"
            />
            <div
              *ngIf="errorMsg && form.get('observacao').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
      <div class="form-group mt-3">
        <div class="row">
          <div class="col-12 pl-0 pr-0">
            <!-- <table
              class="table table-hover table-sm"
              [innerHtml]="tableInfoDoc"
            ></table> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label>Endereço</label>
            <input
              formControlName="endereco"
              name="endereco"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('endereco').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label>Número</label>
            <input
              formControlName="numero"
              name="numero"
              type="text"
              maxlength="10"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('numero').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label>Bairro</label>
            <input
              formControlName="bairro"
              name="bairro"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('bairro').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label>CEP</label>
            <input
              formControlName="cep"
              name="cep"
              type="text"
              mask="00000-000"
              [dropSpecialCharacters]="true"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('cep').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8 pl-0">
          <div class="form-group">
            <label>Complemento</label>
            <input
              formControlName="complemento"
              name="complemento"
              type="text"
              maxlength="255"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('complemento').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-4 pr-0">
          <div class="form-group">
            <label>Contato</label>
            <input
              formControlName="contato"
              name="contato"
              type="text"
              maxlength="50"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('contato').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label>UF</label>
            <select
              formControlName="uf"
              name="uf"
              (change)="searchCities()"
              class="form-control"
            >
              <option *ngFor="let uf of ufs" value="{{ uf }}">{{ uf }}</option>
            </select>
            <div *ngIf="errorMsg && form.get('uf').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label>Cidade</label>
            <select
              formControlName="cidade"
              id="cidade"
              name="cidade"
              class="form-control"
            >
              <option *ngFor="let city of cities" value="{{ city.id }}">
                {{ city.nome }}
              </option>
            </select>
            <div *ngIf="errorMsg && form.get('cidade').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label>Telefone</label>
            <input
              formControlName="ddd"
              name="ddd"
              type="text"
              mask="00"
              placeholder="DDD"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('ddd').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label>&nbsp;</label>
            <input
              formControlName="telefone"
              name="telefone"
              type="text"
              mask="0000-0000"
              [validation]="false"
              [dropSpecialCharacters]="false"
              placeholder="Número"
              class="form-control"
            />
            <div *ngIf="errorMsg && form.get('telefone').invalid" class="error">
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4 pl-0">
          <div class="form-group">
            <label>Whatsapp</label>
            <input
              formControlName="dddwhatsapp"
              name="dddwhatsapp"
              type="text"
              mask="00"
              placeholder="DDD"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('dddwhatsapp').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
        <div class="col-8 pr-0">
          <div class="form-group">
            <label>&nbsp;</label>
            <input
              formControlName="telefonewhatsapp"
              name="telefonewhatsapp"
              type="text"
              mask="00000-0000"
              [validation]="false"
              [dropSpecialCharacters]="false"
              placeholder="Número"
              class="form-control"
            />
            <div
              *ngIf="errorMsg && form.get('telefonewhatsapp').invalid"
              class="error"
            >
              Verifique este campo!
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <button class="btn btn-primary" [disabled]="usuarioService.loading">
        {{ usuarioService.loading ? "Aguarde..." : this.edit ? "Salvar" : "Cadastrar" }}
      </button>
    </div>
  </div>
</form>
